/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input } from '@angular/core';

@Component({
  selector: 'sysque-progress-bar',
  templateUrl: './sysque-progress-bar.component.html',
  styleUrls: ['./sysque-progress-bar.component.scss'],
  standalone: false
})
export class SysqueProgressBarComponent {
  @Input() actionName: string;
  @Input() actionText: string;
  @Input() value: string;
  @Input() isDisabled: boolean;

  format() {
    return '';
  }
}
